<template>
  <div>
    <v-card-title>
      <v-text-field
        v-model="search"
        clearable
        append-icon="mdi-magnify"
        :label="$t('SEARCH')"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="items"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        itemsPerPageOptions: rowsPerPageItems,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right'
      }"
    >
      <template v-slot:item.name="{ item }">
        <strong>{{ item.warehouseName }}</strong> | {{ item.name }}
        <small>({{ item.unitShortName }})</small>
      </template>
      <template v-slot:item.unitValue="{ item }">
        <strong>{{ item.unitValue }}</strong>
        <small> ({{ item.unitShortName }})</small>
      </template>
      <template v-slot:item.poItems="{ item }">
        <template v-for="poItem in item.poItems">
          <v-row v-bind:key="'poItem' + poItem.id">
            <template>
              <v-col cols="12" sm="2">
                <div>
                  <strong>{{ $t("LOT") }}:</strong><br />
                  {{ poItem.lot }}
                </div>
              </v-col>
              <v-col cols="12" sm="2">
                <div>
                  <strong>{{ $t("LOT_EXP_DATE") }}:</strong><br />
                  {{ poItem.lotExpDate }}
                </div>
              </v-col>
              <v-col cols="12" sm="2">
                <div>
                  <strong>{{ $t("SENT") }}:</strong><br />
                  {{ poItem.unitValue }} {{ poItem.unitShortName }}
                </div>
              </v-col>

              <v-col cols="12" sm="2">
                <div>
                  <strong>{{ $t("RECEIVED") }}:</strong><br />
                  {{ poItem.receivedUnitValue }} {{ poItem.unitShortName }}
                </div>
              </v-col>

              <v-col cols="12" sm="2">
                <div>
                  <strong>{{ $t("RETURNED") }}:</strong><br />
                  {{ poItem.returnedUnitValue }} {{ poItem.unitShortName }}
                </div>
              </v-col>

              <v-col cols="12" sm="2">
                <div>
                  <strong>{{ $t("MISSED") }}:</strong><br />
                  {{ poItem.missedUnitValue }} {{ poItem.unitShortName }}
                </div>
              </v-col>

              <v-col cols="12" sm="2">
                <v-text-field
                  hide-details
                  type="number"
                  :label="fromStoreName"
                  v-model="poItem.inSenderUnitValue"
                  :suffix="poItem.unitShortName"
                  :step="poItem.unitNumberType == 2 ? 1 : 0.001"
                  min="0"
                  @blur="filterInSenderUnitValue(poItem)"
                >
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="2">
                <v-text-field
                  hide-details
                  type="number"
                  :label="toStoreName"
                  v-model="poItem.inReceiverUnitValue"
                  :suffix="poItem.unitShortName"
                  :step="poItem.unitNumberType == 2 ? 1 : 0.001"
                  min="0"
                  @blur="filterInReceiverUnitValue(poItem)"
                >
                </v-text-field>
              </v-col>
            </template>
          </v-row>
        </template>
      </template>
      <template v-if="showTotalPrice" slot="body.append">
        <tr class="previewTr">
          <th colspan="100%">
            {{ $t("TOTAL_PRICE") }}:
            {{ itemsTotal }}
          </th>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>
<style scoped>
tr.previewTr th {
  font-size: 18px !important;
}
.v-data-table >>> td {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
}
</style>
<script>
import _ from "lodash";
export default {
  name: "StockPurchaseOrderDiscrepancyItemsTable",
  inheritAttrs: false,
  props: {
    action: {
      type: String,
      default: "review"
    },
    headers: {
      type: Array,
      default: function () {
        return [];
      }
    },
    items: {
      type: Array,
      default: function () {
        return [];
      }
    },
    itemsTotal: {
      type: Array,
      default: function () {
        return [];
      }
    },
    showTotalPrice: {
      type: Boolean,
      default: true
    },
    fromStoreName: {
      type: String,
      default: function () {
        return "";
      }
    },
    toStoreName: {
      type: String,
      default: function () {
        return "";
      }
    }
  },
  data() {
    return {
      search: "",
      rowsPerPageItems: [-1, 100, 10]
    };
  },
  components: {},
  beforeMount() {},
  mounted() {
    this.setMaxReceivedValue();
  },
  computed: {},
  watch: {},
  methods: {
    setMaxReceivedValue() {
      let vm = this;
      //IF status is Shipped -> Receiving, правим инпут за получаване да има дефаулт макса за получаване
      if (_.size(vm.items) > 0 && vm.action == "receiving") {
        vm.items.forEach((requestedItem) => {
          requestedItem.poItems.forEach((poItem) => {
            poItem.receivedUnitValue = poItem.unitValue;
          });
        });
      }
    },
    findInSelect(id, options) {
      console.log(options);
      console.log(id);
      let item = _.find(options, { id: id });
      if (item) {
        return item.name;
      } else {
        return "-";
      }
    },
    filterInSenderUnitValue(poItem) {
      let totalUnitValue =
        parseFloat(poItem.missedUnitValue) +
        parseFloat(poItem.returnedUnitValue);
      let inSenderUnitValue = parseFloat(poItem.inSenderUnitValue);
      let inReceiverUnitValue = parseFloat(poItem.inReceiverUnitValue);
      if (inSenderUnitValue + inReceiverUnitValue > totalUnitValue) {
        //
        poItem.inSenderUnitValue = totalUnitValue - inReceiverUnitValue;
      }
      poItem.inSenderUnitValue = this.formatItemField(
        poItem,
        Math.abs(poItem.inSenderUnitValue)
      );

      poItem.inReceiverUnitValue = this.formatItemField(
        poItem,
        Math.abs(totalUnitValue - poItem.inSenderUnitValue)
      );
    },
    filterInReceiverUnitValue(poItem) {
      let totalUnitValue =
        parseFloat(poItem.missedUnitValue) +
        parseFloat(poItem.returnedUnitValue);
      let inSenderUnitValue = parseFloat(poItem.inSenderUnitValue);
      let inReceiverUnitValue = parseFloat(poItem.inReceiverUnitValue);
      if (inSenderUnitValue + inReceiverUnitValue > totalUnitValue) {
        //
        poItem.inReceiverUnitValue = totalUnitValue - inSenderUnitValue;
      }
      poItem.inReceiverUnitValue = this.formatItemField(
        poItem,
        Math.abs(poItem.inReceiverUnitValue)
      );

      poItem.inSenderUnitValue = this.formatItemField(
        poItem,
        Math.abs(totalUnitValue - poItem.inReceiverUnitValue)
      );
    },
    formatItemField(poItem, value) {
      if (poItem.unitNumberType == 2) {
        value = Math.round(value);
      } else {
        value = this.$options.filters.formatUnitValue(value);
      }
      return value;
    }
  }
};
</script>
